module.exports = __webpack_public_path__ + "static/img/butterflies-left--small.8f16b74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-grounds/butterflies-left--small.svg
// module id = 169
// module chunks = 2